let router = null;

export const initializeRouter = (routerInstance) => {
  router = routerInstance;
};

export const NavigateService = {
  goToDashboard: () => router.navigate('/'),
  goToLogin: () => router.navigate('/login'),
  goToReports: (id) => router.navigate(`/reports/${id}`),
  goToMyAssignment: () => router.navigate('/my-assignment'),
  goToContactTFV: () => router.navigate('/contact-tfv'),
  goToSettings: () => router.navigate('/settings'),
  goToManageUsers: () => router.navigate('/settings/manageusers'),
  goToReportQuality: () => router.navigate('/report-quality'),
  goToTimeSheet: () => router.navigate('/time-sheet'),
  goToNotifications: () => router.navigate('/notifications'),
  goToTranslation: () => router.navigate('/translation'),
  goToNewBooking: () => router.navigate('/new-booking'),
  goToNewTranslation: () => router.navigate('/translation/new-translation'),
  goToNewEmergencyBooking: () => router.navigate('/new-emergency-booking'),
  goToMobileAppLogin: () => router.navigate('/mobile-app/login'),
  goToLogout: () => router.navigate('/logout'),
  goToSetNewPassword: () => router.navigate('/set-new-password'),
  goToForgotPassword: () => router.navigate('/forgot-password'),
  goToChat: () => router.navigate('/chat'),
  goToVersion: () => router.navigate('/version'),
  goToPath: (path) => router.navigate(path),
};

export const NavigationProvider = ({ children, router: routerInstance }) => {
  initializeRouter(routerInstance);
  return children;
};

export const goBack = () => {
  window.history.back();
};

export const goForward = () => {
  window.history.forward();
};

export const goTo = (path) => {
  window.location.href = path;
};

export const reload = () => {
  window.location.reload();
};

export const replace = (path) => {
  window.location.replace(path);
};

export const getPathName = () => window.location.pathname;

export const getSearch = () => window.location.search;

export const getHash = () => window.location.hash;

export const getHost = () => window.location.host;

export const getHostName = () => window.location.hostname;

export const getPort = () => window.location.port;

export const getProtocol = () => window.location.protocol;

export const getOrigin = () => window.location.origin;

export const getHref = () => window.location.href; 